(function () {
  function bindCardCarousels(root) {
    if (!root) return;
    root.querySelectorAll('.card__media-carousel-wrap').forEach(function (wrap) {
      if (wrap.dataset.carouselBound) return;
      wrap.dataset.carouselBound = '1';
      var carousel = wrap.querySelector('[data-card-carousel]');
      var slides = carousel ? carousel.querySelectorAll('.card__carousel-slide') : [];
      if (!slides.length || slides.length <= 1) return;
      var idx = 0;
      var prev = wrap.querySelector('.card__carousel-btn--prev');
      var next = wrap.querySelector('.card__carousel-btn--next');
      function show(nextIdx) {
        idx = (nextIdx + slides.length) % slides.length;
        for (var si = 0; si < slides.length; si++) {
          slides[si].classList.toggle('is-active', si === idx);
        }
      }
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          show(idx - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          show(idx + 1);
        });
      }
    });
  }

  function bindBeneficios(root) {
    if (root && typeof window.initOleumCardBeneficiosIn === 'function') {
      window.initOleumCardBeneficiosIn(root);
    }
  }

  function bindScrollProgress(wrapper) {
    if (!wrapper) return;
    var grid = wrapper.querySelector('[data-carousel-scroll]') || wrapper.querySelector('.favoritos-grid--carousel');
    var fill = wrapper.querySelector('[data-carousel-progress-fill]');
    if (!grid || !fill) return;
    if (grid.dataset.progressBound) return;
    grid.dataset.progressBound = '1';
    function update() {
      var max = grid.scrollWidth - grid.clientWidth;
      var pct = max <= 0 ? 100 : (grid.scrollLeft / max) * 100;
      fill.style.width = pct + '%';
    }
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function shouldUseCarousel(grid) {
    if (!grid || !grid.closest('[data-oleum-carousel]')) return false;
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function initGrid(root) {
    bindCardCarousels(root);
    bindBeneficios(root);
    var grid = root.querySelector('.favoritos-grid');
    if (grid && grid.querySelectorAll('.grid__item').length > 0 && shouldUseCarousel(grid)) {
      grid.classList.add('favoritos-grid--carousel');
    }
  }

  function init() {
    document.querySelectorAll('[data-favoritos-grid]').forEach(function (grid) {
      var root = grid.closest('[data-oleum-carousel]') || grid.parentElement;
      initGrid(root || grid);
      if (root && root.hasAttribute('data-oleum-carousel')) {
        bindScrollProgress(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var grid = e.target.querySelector('[data-favoritos-grid]');
    if (grid) {
      var root = grid.closest('[data-oleum-carousel]') || grid.parentElement;
      initGrid(root || grid);
      if (root && root.hasAttribute('data-oleum-carousel')) {
        bindScrollProgress(root);
      }
    }
  });
})();
